const WhySparksHeating = ()=>{
return(
    <section className="same_space pt-0 ">
        <div className="sparks_heating_wepper">
            <div className="container">
                <div className="sparks_heating_hedding">
                    <h2>Why Sparks Heating and Air?</h2>
                </div>
                <div className="row">
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                        <div className="sparks_heating_box">
                            <img src="images/spakrs-heating1.png" alt="" />
                            <h2>Round the Clock Availability</h2>
                            <p>
                                Be it the scorch of the summer or frosty winter, we’ll be available within 48 hours to
                                help
                                when the unexpected happens. Our experts are just a call away.
                            </p>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                        <div className="sparks_heating_box">
                            <img src="images/spakrs-heating2.png" alt="" />
                            <h2>100% Satisfaction and Guarantee</h2>
                            <p>
                                Our mission is to make the customers a priority and so we try to include warranties on
                                all our services. We make our customers happy and satisfied.
                            </p>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                        <div className="sparks_heating_box">
                            <img src="images/spakrs-heating3.png" alt="" />
                            <h2>Years of Expertise</h2>
                            <p>
                                Our customers choose us for HVAC services in Denver since we provide professional and
                                efficient service. We have a reputation for being trustworthy in the Denver Metro area.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>


)
}
 

export default WhySparksHeating;